const DOCUMENT_SCROLL_LOCK = Symbol.for("chalk.modal.documentScrollLock");

type ScrollLockedDocument = Document & {
  [DOCUMENT_SCROLL_LOCK]?: {
    count: number;
    overflow: string;
    overscroll: string;
  };
};

export function lockDocumentScroll() {
  const target = document as ScrollLockedDocument;
  // The document owns the lease count, including locks from independent React providers.
  const state = (target[DOCUMENT_SCROLL_LOCK] ??= {
    count: 0,
    overflow: target.body.style.overflow,
    overscroll: target.documentElement.style.overscrollBehavior,
  });
  state.count++;
  target.body.style.overflow = "hidden";
  target.documentElement.style.overscrollBehavior = "none";
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--state.count !== 0) return;
    target.body.style.overflow = state.overflow;
    target.documentElement.style.overscrollBehavior = state.overscroll;
    delete target[DOCUMENT_SCROLL_LOCK];
  };
}
